import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useEpikBoxCas = (
  numberOfChannel,
  bchannel,
  channelRange,
  echoheckBox,
  defaultCas,
  casFailovers,
  sortedCasList,
) => {
  const casSettings = useSelector(state => state.AppState.priSipData?.sipSettingData);

  const [dropDownStates, setDropDownStates] = useState({
    timeAndSource: casSettings?.timeAndSource || 'internal' ,
    switchType: casSettings?.switchType || 'national',
    echoCancellationType: 'mg2',
    framing: 'esf',
    lineOfCode: 'b8zs',
    numberOfChannel: 24,
    bChannel: '1-24',
    channelRange: '1-24',
  });


  const handleDropDownStates = useCallback(
    (name, value) => {
      setDropDownStates({ ...dropDownStates, [name]: value });
    },
    [dropDownStates],
  );

  const produceState = useCallback(() => {
    let casFailoversList = [];
    if (sortedCasList?.length === casFailovers?.length) {
      casFailoversList = sortedCasList;
    } else {
      casFailoversList = casFailovers;
    }
    return {
      ...dropDownStates,
      channels: numberOfChannel,
      bChannels: bchannel,
      echoChannels: channelRange,
      echoCancellation: echoheckBox,
      casFailovers: casFailoversList,
    };
  }, [dropDownStates, numberOfChannel, bchannel, channelRange, echoheckBox, casFailovers, sortedCasList]);

  return {
    produceState,
    dropDownStates,
    handleDropDownStates,
  };
};

export default useEpikBoxCas;
